import React from "react";

import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";

export default function DeckSelect({
   decks,
   selected,
   column,
   slot,
   callback,
}) {
   const handleChange = (e) => {
      callback(column, slot, e.target.value || null);
   };

   const deckLabel = (deck) => {
      const name = deck.AdminGivenName || deck.DecklistName || "Unnamed Deck";
      return deck.FormatName ? `${name} (${deck.FormatName})` : name;
   };

   return (
      <FormControl fullWidth size='small'>
         <InputLabel id={`deckSelect-${column}-${slot}`}>Deck</InputLabel>
         <Select
            value={selected || ""}
            label='Deck'
            onChange={handleChange}
         >
            <MenuItem value=''>No Deck Selected</MenuItem>
            {decks &&
               decks.map((deck) => (
                  <MenuItem key={deck.Guid} value={deck.Guid}>
                     {deckLabel(deck)}
                  </MenuItem>
               ))}
         </Select>
      </FormControl>
   );
}
